'use client'

import { Badge, Icon, type IconType } from '@vinted/web-ui'

type Props = {
  id: string
  iconType: IconType
  content: string | null
  isVisible: boolean
}

const DiscountBadge = ({ id, iconType, content, isVisible }: Props) =>
  isVisible && (
    <Badge
      testId={`${id}-discount-badge`}
      theme="warning"
      styling="filled"
      icon={
        <Icon
          name={iconType}
          color="greyscale-level-6"
          aria={{
            'aria-hidden': 'true',
          }}
        />
      }
      content={content}
    />
  )

export default DiscountBadge
